// Values were taken by looking at the "measure_units" SQL table
export enum MeasureUnitValues {
  None = '',
  Hours = 'Hours',
  Miles = 'Miles',
  Feet = 'Feet',
  Kilometers = 'Kilometers',
  Meters = 'Meters',
  Bool = 'YES/NO',
}

export const MeasureUnitAbbreviations = {
  [MeasureUnitValues.None]: '',
  [MeasureUnitValues.Hours]: 'hrs',
  [MeasureUnitValues.Miles]: 'mi',
  [MeasureUnitValues.Feet]: 'ft',
  [MeasureUnitValues.Kilometers]: 'km',
  [MeasureUnitValues.Meters]: 'meters',
  [MeasureUnitValues.Bool]: '',
} as const;
